module.exports = __webpack_public_path__ + "static/recon-banner-5e910413ce9573df9a4a938ab3a608d6.png";